export function queryParamForward() {
    let query_str =  new URL(window.location.href);
    query_str = query_str.search.substring(1);
    
    let paramsForward = document.querySelector('#queryParamsForward');
    const prodUrlForward = document.querySelector('#prodUrlForward');
    const devUrlForward = document.querySelector('#devUrlForward');
    let itemsAppendQryParams = document.querySelector('#itemsAppendQryParams');

    if (!paramsForward || !prodUrlForward || !devUrlForward || !itemsAppendQryParams) {
        return;
    }

    paramsForward = paramsForward.value.trim();
    const params = new URLSearchParams(query_str);
    const processedParams = paramsForward.split(',').map(param => param.trim());

    // Build a safe query param set using URLSearchParams to ensure proper encoding
    const forwardParams = new URLSearchParams();
    processedParams.forEach(param => {
        if (params.has(param)) {
            const value = params.get(param);
            if (typeof value === 'string') {
                forwardParams.set(param, value);
            }
        }
    });

    try {
        itemsAppendQryParams = JSON.parse(itemsAppendQryParams.value.trim());
    } catch (error) {
        console.error(error);
        return;
    }

    const originationsURL = window.location.origin === 'https://oportun.com' ? prodUrlForward.value.trim() : devUrlForward.value.trim();

    function appendForwardParams(button) {
        try {
            // Destination URL
            const url = new URL(originationsURL, window.location.origin);

            // Existing URL from the button
            const currentButtonUrl = new URL(
                button.href,
                window.location.origin
            );

            // 1. Preserve existing params from the button
            currentButtonUrl.searchParams.forEach((value, key) => {
                url.searchParams.set(key, value);
            });

            // 2. Add/replace params received in forwardParams
            forwardParams.forEach((value, key) => {
                url.searchParams.set(key, value);
            });

            button.href = url.toString();
        } catch (error) {
            console.error('Invalid originations URL', error);
        }
    }

    function forwardSplParamsWhenReady(button) {
        const hasEvaluationPlaceholder = () => {
            return (button.getAttribute('href') || '').includes('###ID###');
        };

        if (!hasEvaluationPlaceholder()) {
            appendForwardParams(button);
            return;
        }

        const observer = new MutationObserver(() => {
            if (!hasEvaluationPlaceholder()) {
                observer.disconnect();
                appendForwardParams(button);
            }
        });

        observer.observe(button, {
            attributes: true,
            attributeFilter: ['href']
        });
    }

    itemsAppendQryParams.forEach(element => {
        document.querySelectorAll(element.item_selector).forEach(button => {
            const buttonText = button.innerText.toLowerCase();
            const validText = element.item_selector_text.split(',');

            if (!validText.some(text => buttonText.includes(text.trim().toLowerCase())) || !(button instanceof HTMLAnchorElement)) return;

            if (button.id === 'splapply') {
                forwardSplParamsWhenReady(button);
                return;
            }

            appendForwardParams(button);

            button.addEventListener('contextmenu', () => {
                appendForwardParams(button);
            });
        });
    });
}

export function queryParamForwardleadId() {
    // Get query string from current URL
    let query_str =  new URL(window.location.href);
    query_str = query_str.search.substring(1);

    let queryGlobalParamsForward = document.querySelector('#queryGlobalParamsForward');

    let queryParamLang = '';
    if (window.location.href.indexOf("/es/") > -1) {
       queryParamLang = '&lang=es';
    } else {
        queryParamLang = '&lang=en';
    }
    if(!queryGlobalParamsForward){
        return;
    }
    
    queryGlobalParamsForward = queryGlobalParamsForward.value.trim();
    const params = new URLSearchParams(query_str);
    const leadId = params.get('leadId');

    if (![...params.keys()].length) {
        console.warn('No query parameters found in URL.');
        return;
    }
    if ( (!leadId || (typeof leadId === 'string' && leadId.trim() === '')) && !/\/info\//.test(window.location.pathname)) {
        console.warn('No leadId in query and not on /info/ page.');
        return;
    }

    const marketing_source = sessionStorage.getItem("marketing_source");
    if (!/leadId:[0-9]{15}/.test(marketing_source)){
        sessionStorage.setItem("leadId", marketing_source + leadId);
        sessionStorage.setItem("leadId", leadId );
    } else{
        sessionStorage.setItem("leadId", leadId );
    }

    const processedParams = queryGlobalParamsForward.split(',').map(param => param.trim());
    const queryString = processedParams
        .map(param => params.has(param) ? `${param}=${params.get(param)}` : '')
        .filter(param => param !== '')
        .join('&');

    // Helper function to append leadId to a URL, handling first or subsequent query string
    function appendLeadId(url) {
        if (!url) return url;
        // delete any existing leadId
        let cleanUrl = url.replace(/([&?])leadId=\d{1,}/, '$1').replace(/([&?])leadId=[^&]*(&)?/, '$1');
        // delete the extra &
        cleanUrl = cleanUrl.replace(/([&?])$/, '');
        const hasQuery = cleanUrl.includes('?');
        // Validate leadId before using replace
        let safeLeadId = (typeof leadId === 'string') ? leadId.replace(/[^0-9]/g, '') : '';
        if (!safeLeadId) return cleanUrl; // if no safeLeadId, don't add it
        const leadIdParam = `leadId=${safeLeadId}` + queryParamLang;
        return cleanUrl + (hasQuery ? '&' : '?') + leadIdParam;
    }

    const browserWidth = window.innerWidth;
    if (browserWidth < 768) {
        const cta = document.querySelector('div.ctamobile a.cta-mobile.button');
        if (cta) {
            cta.href = appendLeadId(cta.href);
        } else {
            console.warn('CTA mobile button not found.');
        }
    } else {
        const component = document.querySelector('oportun-apply-button');
        if (!component || !component.shadowRoot) {
            console.warn('oportun-apply-button or its shadowRoot not found.');
        } else {
            const slot = component.shadowRoot.querySelector('slot');
            if (!slot) {
                console.warn('Slot not found in oportun-apply-button.');
            } else {
                const assigned = slot.assignedElements();
                const anchor = assigned.find(el => el.tagName === 'A');
                if (anchor) {
                    anchor.href = appendLeadId(anchor.href);
                } else {
                    console.warn('Anchor not found in slot.');
                }
            }
        }
    }
    // update all links with href, not just those from apply/aplica.oportun.com
    const allLinks = document.querySelectorAll('a[href]');
    allLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href && href.startsWith('https://')) {
            link.href = appendLeadId(href);
        }
    });

    // update the shadow DOM links
    const shadowHosts = Array.from(document.querySelectorAll('oportun-slider, oportun-list'));
    for (const host of shadowHosts) {
        if (!host.shadowRoot) {
            console.warn('Shadow root not found for', host);
            continue;
        }
        // Find all oportun-list-item elements inside shadow DOM
        const listItems = Array.from(host.shadowRoot.querySelectorAll('oportun-list-item'));
        for (const listItem of listItems) {
            // Find all <a> elements within each list item
            const links = Array.from(listItem.querySelectorAll('a'));
            links.forEach(link => {
                const href = link.getAttribute('href');
                if (href && href.startsWith('https://')) {
                    link.href = appendLeadId(href);
                }
            });
        }
    }
}

export function handleQueryParams() {
    // verify the elements needed to execute queryParamForward
    const paramsForward = document.querySelector('#queryParamsForward');
    const prodUrlForward = document.querySelector('#prodUrlForward');
    const devUrlForward = document.querySelector('#devUrlForward');
    const itemsAppendQryParams = document.querySelector('#itemsAppendQryParams');

    if (paramsForward && prodUrlForward && devUrlForward && itemsAppendQryParams) {
        queryParamForward();
        return;
    }

    // verify the elements needed to execute queryParamForwardleadId
    const queryGlobalParamsForward = document.querySelector('#queryGlobalParamsForward');

    if (queryGlobalParamsForward) {
        queryParamForwardleadId();
        return;
    }

}

export function queryParamSessionStorageLeadId() {
    let leadId = sessionStorage.getItem("leadId");
    if (leadId === null) {
        return;
    }

    // Helper function to append leadId to a URL, handling first or subsequent query string
    function appendLeadId(url) {
        if (!url) return url;
        const hasQuery = url.includes('?');
        const leadIdParam = `leadId=${leadId.replace(/[^0-9]/g, '')}`;
        // Avoid duplicate leadId parameter
        if (url.includes('leadId=')) return url;
        return url + (hasQuery ? '&' : '?') + leadIdParam;
    }

    // Modify CTA in navbar based on browser width
    const browserWidth = window.innerWidth;
    if (browserWidth < 768) {
        const cta = document.querySelector('div.ctamobile a.cta-mobile.button');
        if (cta) cta.href = appendLeadId(cta.href);
    } else {
        const component = document.querySelector('oportun-apply-button');
        if (!component) return null;
        const slot = component.shadowRoot.querySelector('slot');
        const assigned = slot.assignedElements();
        const anchor = assigned.find(el => el.tagName === 'A');
        if (anchor) {
            anchor.href = appendLeadId(anchor.href);
        }
    }

    // Update all "Apply Now" buttons with leadId
    const applyNowButtons = document.querySelectorAll('a.button, a.btn');
    applyNowButtons.forEach(button => {
        const href = button.getAttribute('href');
        // Only update URLs matching apply/aplica.oportun.com
        if (href && /https:\/\/(apply|aplica)\.oportun\.com(\/.*)?/.test(href)) {
            button.href = appendLeadId(href);
        }
    });

    // Update links inside shadow DOM components with leadId
    const shadowHosts = Array.from(document.querySelectorAll('oportun-slider, oportun-list'));
    for (const host of shadowHosts) {
        // Find all oportun-list-item elements inside shadow DOM
        const listItems = Array.from(host.shadowRoot.querySelectorAll('oportun-list-item'));
        for (const listItem of listItems) {
            // Find all <a> elements within each list item
            const links = Array.from(listItem.querySelectorAll('a'));
            links.forEach(link => {
                const href = link.getAttribute('href');
                // Only update URLs matching apply/aplica.oportun.com
                if (href && /https:\/\/(apply|aplica)\.oportun\.com(\/.*)?/.test(href)) {
                    link.href = appendLeadId(href);
                }
            });
        }
    }
}

export function queryParamClientId_and_visitorId(retries = 5) {
  const path = location.pathname.toLowerCase();
  if (
    !/^\/locations\/state\/.+/.test(path) &&
    !/^\/sucursales\/estado\/.+/.test(path)
  ) {
    return;
  }

  const visitorId = window?.utag_data?.tealium_visitor_id;
  const validVisitorId = typeof visitorId === 'string' && visitorId && visitorId !== 'null';

  if (!validVisitorId) {
    if (retries > 0) return setTimeout(() => queryParamClientId_and_visitorId(retries - 1), 300);
    console.warn('[deviceid] visitorId not available');
    return;
  }

  const selector = 'a.button, a.btn';
  document.querySelectorAll(selector).forEach(a => {
    const href = a.getAttribute('href');
    if (!href) return;
    if (!href.startsWith('https://www.moneylion.com/network/oportun/loans/search/')) return;
    if (href.includes('tag.deviceid=')) return;
    a.href = href + (href.includes('?') ? '&' : '?') + 'tag.deviceid=' + encodeURIComponent(visitorId) + "&sourceId=ocw-locations";
  });

  console.log('[deviceid] applied:', visitorId);
}
